import React, { Component, useEffect } from "react";
import { connect } from "react-redux";

import styles from "./PopularCategories.scss";
import { selectCategories, selectModules } from "../../App/selectors";
import { getPopulars, selectPopulars } from "../../../routes/Ad/ad.ducks";
import { PageRoute } from "../../../models/enums";
import { PopularMobile } from "./PopularMobile";
import { PopularDesktop } from "./PopularDesktop";
import Skeleton from "../../../components/Skeleton";
import { checkEmptyArray } from "../../../services";

const rowGutter: any = { xs: 4, sm: 4, md: 4, lg: 4, xl: 24 };

function PopularCategories(props: any) {
  const { modules, categories, populars, title, isMobile, getPopulars } = props;

  useEffect(() => {
    if (!populars || !checkEmptyArray(populars)) {
      getPopulars(modules, categories);
    }
  }, [modules, categories]);

  const getPopularKey = (popular: any) =>
    `${popular.module}${popular.category ? `-${popular.category}` : ""}`;

  const getPopularLink = (popular: any) => {
    if (!popular.category) {
      return `/${popular.module}`;
    }

    return `/${popular.module}/${popular.category}`;
  };

  if (populars.length > 1 && populars.length < 6) {
    return null;
  }

  if (populars.length < 6) {
    return (
      <div
        className={styles.skeletonWrapper}
        style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}>
        <Skeleton style={{ height: 200, width: isMobile ? "40%" : "100%" }} />
        <Skeleton style={{ height: 200, width: isMobile ? "40%" : "100%" }} />
        <Skeleton style={{ height: 200, width: isMobile ? "40%" : "100%" }} />
        <Skeleton style={{ height: 200, width: isMobile ? "40%" : "100%" }} />
        <Skeleton style={{ height: 200, width: isMobile ? "40%" : "100%" }} />
        <Skeleton style={{ height: 200, width: isMobile ? "40%" : "100%" }} />
      </div>

    )
  }

  return (
    <div className={`${styles.popularCategoriesSection}`}>
      {!isMobile ? (
        <PopularDesktop populars={populars} />
      ) : (
        <PopularMobile populars={populars} />
      )}
    </div>
  );
}

PopularCategories.defaultProps = {
  title: "Popularno",
  isMobile: false
};

function mapStateToProps(state: any) {
  return {
    modules: selectModules(state),
    categories: selectCategories(state),
    populars: selectPopulars(state)
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    getPopulars: (modules: any, categories: any) =>
      dispatch(getPopulars(modules, categories))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PopularCategories);



// WEBPACK FOOTER //
// ./src/containers/HomePage/PopularCategories/PopularCategories.tsx